import { GetPlantSupplierDto, GetPlantSerialNumberDto, PlantHoursDto, AllocationSheetStatus, GetPlantLocationDto } from './../../../../../../shared/service-proxies/service-proxies';
import { Component, Injector, ViewChild } from "@angular/core";
import { ActivitiesServiceProxy, PlantsServiceProxy } from "@shared/service-proxies/service-proxies";
import { DashboardChartBase } from "../dashboard-chart-base";
import { MatSelect } from '@angular/material/select';
import { FormControl } from '@angular/forms';

@Component({
    selector: 'app-widget-plant-graph',
    templateUrl: './widget-plant-graph.component.html',
    styleUrls: ['./widget-plant-graph.component.scss'],
  })
  export class WidgetPlantGraphComponent extends DashboardChartBase {
    plantHours: PlantHoursDto[];
    suppliers: GetPlantSupplierDto[]
    serialNumbers: GetPlantSerialNumberDto[]
    locations: GetPlantLocationDto[]
    chartData: any[] = [];
    scheme: any = {
      domain: ['#0085E7', '#EEF0F8'],
    };
    showXAxis: boolean = true;
    @ViewChild('supplierSelector', { static: true }) supplierSelector: MatSelect;
    public supplierFormCtrl: FormControl = new FormControl();
    @ViewChild('serialNumberSelector', { static: true }) serialNumberSelector: MatSelect;
    public serialNumberFormCtrl: FormControl = new FormControl();
    @ViewChild('locationSelector', { static: true }) locationSelector: MatSelect;
    public locationFormCtrl: FormControl = new FormControl();
    constructor(
      private _activitiesServiceProxy: ActivitiesServiceProxy,
      private _plantsServiceProxy: PlantsServiceProxy
    ) {
      super();
    }

    ngOnInit() {
      this.loadData();
    }
    async loadData(){
      let [plantHours, locations, suppliers, serialNumbers] = await Promise.all([
        this._plantsServiceProxy.getPlantHoursForProject().toPromise(),
        this._activitiesServiceProxy.getPlantLocations().toPromise(),
        this._activitiesServiceProxy.getPlantSuppliers().toPromise(),
        this._activitiesServiceProxy.getPlantSerialNumbers().toPromise()
      ]);
      this.plantHours = plantHours.plantHours;
      this.suppliers = suppliers;
      this.serialNumbers = serialNumbers;
      this.locations = locations;
      this.setChartData([],[],[]);
    }
    groupBy<T>(arr: T[], fn: (item: T) => any) {
      return arr.reduce<Record<string, T[]>>((prev, curr) => {
        const groupKey = fn(curr);
        const group = prev[groupKey] || [];
        group.push(curr);
        return { ...prev, [groupKey]: group };
      }, {});
    }
    setChartData(suppliers: string[], serialNumbers: string[], locations: string[]) {
      var filteredHours = this.plantHours;
      if (suppliers.length > 0) {
        filteredHours = filteredHours.filter((f) => suppliers.some(c=> c == f.supplierName));
      }
  
      if (serialNumbers.length > 0) {
        filteredHours = filteredHours.filter((f) => serialNumbers.some(c=> c == f.serialNumber));
      }

      if (locations.length > 0) {
        filteredHours = filteredHours.filter((f) => locations.some(c=> c == f.location));
      }
  
      let hours = this.groupBy(filteredHours, (e) => {
        return e.workDay.format('DD-MM-YYYY');
      });
      var chartData = [];
      Object.entries(hours).forEach((element) => {
        chartData.push({
          name: element[0],
          series: [
            {
              day: element[0],
              name: 'Hours approved by Admin',
              value: element[1]
                .filter(
                  (h) => h.status == AllocationSheetStatus.ApprovedByProjectAdmin
                )
                .reduce(function (a, b) {
                  return a + b.actualHours;
                }, 0),
            },
            {
              day: element[0],
              name: 'Hours to be submitted',
              value: element[1]
                .filter(
                  (h) => h.status !== AllocationSheetStatus.ApprovedByProjectAdmin
                )
                .reduce(function (a, b) {
                  return a + b.actualHours;
                }, 0),
            },
          ],
        });
      });

      //fake additional data, graph looks odd in case of less data
      for(let i = chartData.length; i<6; i++){
        let name = '';
        for (let index = 0; index < i; index++) {
            name = name + ' ';
        }
        chartData.push({name: name, series: []});
      }
      this.chartData = [...chartData];
    }
  
    selectedSupplier(event: any) {
      this.setChartData(event.value, [], []);
    }
    selectedSerialNumber(event: any) {
      this.setChartData([], event.value, []);
    }
    selectedLocation(event: any) {
      this.setChartData([], [], event.value);
    }
  }